import { loadStripe } from '@stripe/stripe-js';
import EnvHandler from './EnvHandler';

const stripe = process.env.REACT_APP_STRIPE_PUBLIC_KEY ? loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY) : null

if (EnvHandler.isDevMode()) console.log(process.env);

export default {
    getNewStripeInstance: () => {
        return stripe;
    }
}